import { useRef } from 'react';

import { CheckIcon } from 'lucide-react';

import { TDealDetails } from '@crm/entities/deal';
import ElbowDown from '@crm/shared/assets/icons/elbow-down.svg?react';
import { useIsClamped } from '@crm/shared/lib';
import { SelectItem, SvgIcon } from '@crm/shared/ui';

export const PipelineColumnItem = ({
    column,
}: {
    column: TDealDetails['pipelineColumnsData']['columns'][number];
}) => {
    const titleRef = useRef<HTMLSpanElement>(null);
    const isTitleClamped = useIsClamped(titleRef);

    return (
        <SelectItem
            value={String(column.id)}
            showIndicator={false}
            title={isTitleClamped ? column.title : undefined}
            className="group relative h-9 w-full min-w-0 cursor-pointer px-1.5 transition-opacity hover:opacity-70 focus:bg-transparent"
        >
            <div className="grid w-full min-w-0 grid-cols-[0rem_1fr] items-center transition-[grid-template-columns] group-hover:grid-cols-[1.25rem_1fr]">
                <div
                    aria-hidden="true"
                    className="overflow-hidden leading-none opacity-0 transition-opacity group-hover:opacity-100"
                >
                    <SvgIcon icon={ElbowDown} size="16" color="currentColor" />
                </div>
                <div
                    className="flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-2 pr-3 whitespace-nowrap"
                    style={{
                        backgroundColor: column.bgColor,
                        color: column.color,
                    }}
                >
                    <span
                        className="size-2 shrink-0 rounded-full"
                        style={{ backgroundColor: column.color }}
                    />
                    <span ref={titleRef} className="min-w-0 truncate">
                        {column.title}
                    </span>
                    {column.isActive && (
                        <CheckIcon aria-hidden="true" className="ml-auto size-4 shrink-0" />
                    )}
                </div>
            </div>
        </SelectItem>
    );
};
